import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import './SurveyWrapper.scss';

type SurveyWrapperProps = {
  className?: string;
};

export const SurveyWrapper: React.FC<PropsWithChildren<SurveyWrapperProps>> = ({
  className,
  children,
}) => {
  return <div className={clsx('survey-container-wrapper', className)}>{children}</div>;
};
